// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Drawings_imgContainer__Am0H7","img":"Drawings_img__1Y8DZ","imgLamp":"Drawings_imgLamp__mKAXY"};